"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.correctNodes = exports.correctNode = void 0;

var is_1 = require("./is");

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(is_1.isRadioElement).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var correctNode = function correctNode(node, nodes) {
  if ((0, is_1.isRadioElement)(node) && node.name) {
    return findSelectedRadio(node, nodes);
  }

  return node;
};

exports.correctNode = correctNode;
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */

var correctNodes = function correctNodes(nodes) {
  // IE11 has no Set(array) constructor
  var resultSet = new Set();
  nodes.forEach(function (node) {
    return resultSet.add((0, exports.correctNode)(node, nodes));
  }); // using filter to support IE11

  return nodes.filter(function (node) {
    return resultSet.has(node);
  });
};

exports.correctNodes = correctNodes;